import { Col, Row } from "reactstrap";
import AdminPage from "../../components/admin/AdminPage";
import AdminUploadResource from "../../components/admin/AdminUploadResource";
import AdminResourceGallery from "../../components/admin/AdminResourceGallery";
import useAdminEntity from "../../hooks/useAdminEntity";
import { useCallback, useState } from "react";
import { DevManagementDetail } from "./models/developerManagement";
import { useNavigate, useParams } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { getDeveloperDetailsEndpoint, updateDeveloperAvatarEndpoint } from "./services/developersService";
import useCallApiAndLoad from "../../hooks/useCallApiAndLoad";
import LoadingCard from "../../components/LoadingCard";




const ModelDeveloperUploadAvatar = () => {

  const { id: developerId = '' } = useParams();

  const { isLoading, callEndpoint } = useCallApiAndLoad();
  const navigate = useNavigate();
  const { getAuthToken } = useAuth();
  const token = getAuthToken();

  const [errorAlert, setErrorAlert] = useState<any>(null);

  const pageName = `Actualizar avatar de desarrolladora`;
  const pageParentName = `Inversiones`;
  const globalAlertOptions = {
    success: false,
    warning: true,
    onConfirm: () => setErrorAlert(null),
    title: 'Error',
    text: errorAlert || '',
  };
  const getDeveloperModel = useCallback(
    () =>
      getDeveloperDetailsEndpoint(
        developerId,
        token,
      ),
    [developerId, token],
  );

  const [investorDevManagement] = useAdminEntity<DevManagementDetail>(
    getDeveloperModel,
    setErrorAlert,
  );

  const uploadDeveloperAvatar = useCallback(
    async (files: Array<any>) => {
      if (files.length < 0) return;

      const formData = new FormData();
      files.forEach((file) => formData.append('avatar', file));
      const { status } = await callEndpoint(
        updateDeveloperAvatarEndpoint(
          developerId,
          formData,
          token,
        ),
      );

      if (status === 200) navigate(0);
    },
    [developerId, callEndpoint, navigate, token],
  );

  if (!investorDevManagement || isLoading)
    return <LoadingCard name={pageName} parent_name={pageParentName} />;

  return (
    <AdminPage
      name={pageName}
      parentName={pageParentName}
      globalAlertOptions={globalAlertOptions}
    >
      <Row>
        <Col>
          <AdminUploadResource
            handleUpload={uploadDeveloperAvatar}
            description={'Subir avatar'}
            maxFiles={1}
          />
        </Col>
        <Col>
          <AdminResourceGallery
            gallery={investorDevManagement.avatar ? [investorDevManagement.avatar] : []}
            description={'Avatar actual'}
          />
        </Col>
      </Row>
    </AdminPage>
  );
};

export default ModelDeveloperUploadAvatar;